import { Component } from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData, JsonPipe } from '@angular/common';
import localeHe from '@angular/common/locales/he';
import localeHeExtra from '@angular/common/locales/extra/he';
import localeEn from '@angular/common/locales/en';
import localeEnExtra from '@angular/common/locales/extra/en';
import { environment } from 'src/environments/environment';
import { IdleTimeService } from './core/services/idle-time.service';
import { Router, NavigationStart, NavigationEnd, NavigationError, Event } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import moment from 'moment';
//import momentHeConfig from 'moment/locale/he';
import { AppData } from './app.data';
import { Utils } from './core/utils';
import { OpenReplayService } from './core/services/open-replay.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'DrWebMobile';
  public settings: Settings;

  constructor(
    public appSettings: AppSettings,
    public appData: AppData,
    public translate: TranslateService,
    idleService: IdleTimeService,
    private router: Router,
    private cookieService: CookieService,
    private openReplayService : OpenReplayService) {

    // IdleTimeService => when the idleService is initiated it start the session count down
    console.log('environment: ' + environment.name); // Logs false for default environment
    console.log('apiEndPoint: ' + Utils.getApiEndPoint());

    this.settings = appSettings.settings;
    this.initLanguages();
    this.settings.loadingSpinner = false; // to fix error of expression result in console
    // this.trackRouting();
    
    this.openReplayService.startSession();
  }

  trackRouting() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
        console.log('NavigationStart:' + event.url);
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
        console.log('NavigationEnd: ' + event.url);
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        console.log(event.error);
      }
    });
  }

  initLanguages() {
    

    let currentLoggedLang = this.appData.userLanguage || this.translate.getBrowserLang(); // first login => take browsers default lang | app refreshs take logged users settings lang
    // ngx-transaltion
    this.translate.addLangs(['en', 'he']);

    const cookieCulture = this.cookieService.get('.AspNetCore.Culture');
    if(cookieCulture){
      const culture = cookieCulture.split('|')[0].replace('c=', '').split('-')[0]; // he
      if(culture){
        currentLoggedLang = culture;
      }
    }

    
     // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang(currentLoggedLang);
    
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use(currentLoggedLang);

    this.settings.locale = currentLoggedLang;

    if (this.translate.currentLang == 'he') {
      this.settings.rtl = true;
    
    } else {
      this.settings.rtl = false;
    }

    moment.updateLocale(this.translate.currentLang, localeHeExtra);


    // i18n translation - https:// angular.io/guide/i18n#i18n-pipes. MORE SETTINGS IN MAIN.TS
    registerLocaleData(localeHe, 'he', localeHeExtra); // this allow date format 
    registerLocaleData(localeEn, 'en', localeEnExtra); // this allow date format 
  }
}
